var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"date-range"},[_c('a-range-picker',{staticClass:"dashboard-date-range",attrs:{"format":_vm.dateFormat,"value":_vm.dates},on:{"change":_vm.onToDateChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }